const DEFAULT_SITE_URL = 'https://tnh.com.vn';

const ROUTE_SEO = {
    vn: {
        '/': {
            title: 'TNH Hospital Group | Hệ thống bệnh viện chất lượng cao',
            description:
                'TNH Hospital Group cung cấp dịch vụ chăm sóc sức khỏe an toàn, nhân văn, chất lượng cao với hệ thống bệnh viện hiện đại tại miền Bắc.',
        },
        '/gioi-thieu': {
            title: 'Giới thiệu TNH Hospital Group | Tầm nhìn 2035',
            description:
                'Tìm hiểu sứ mệnh, tầm nhìn 2035, giá trị cốt lõi và hành trình phát triển của TNH Hospital Group.',
        },
        '/tin-tuc': {
            title: 'Tin tức y tế và sức khỏe | TNH Hospital Group',
            description:
                'Cập nhật kiến thức sức khỏe, hoạt động bệnh viện và thông tin y tế mới nhất từ TNH Hospital Group.',
        },
        '/chuyen-gia-bac-si': {
            title: 'Đội ngũ chuyên gia, bác sĩ | TNH Hospital Group',
            description:
                'Tìm kiếm chuyên gia, bác sĩ theo chuyên khoa và cơ sở y tế trong hệ thống TNH Hospital Group.',
        },
        '/co-so-y-te': {
            title: 'Hệ thống bệnh viện TNH | Cơ sở y tế hiện đại',
            description:
                'Khám phá mạng lưới bệnh viện, cơ sở y tế hiện đại và thông tin liên hệ trong hệ thống TNH Hospital Group.',
        },
        '/chuyen-khoa': {
            title: 'Các chuyên khoa y tế | TNH Hospital Group',
            description:
                'Tra cứu các chuyên khoa, kỹ thuật điều trị và dịch vụ chăm sóc sức khỏe tại hệ thống bệnh viện TNH.',
        },
        '/goi-dich-vu': {
            title: 'Gói dịch vụ chăm sóc sức khỏe | TNH Hospital Group',
            description:
                'Tham khảo các gói khám, tầm soát và chăm sóc sức khỏe toàn diện tại hệ thống bệnh viện TNH.',
        },
        '/uu-dai': {
            title: 'Chương trình ưu đãi y tế | TNH Hospital Group',
            description: 'Cập nhật chương trình ưu đãi khám chữa bệnh và chăm sóc sức khỏe mới nhất từ TNH.',
        },
        '/tuyen-dung': {
            title: 'Cơ hội nghề nghiệp | TNH Hospital Group',
            description: 'Khám phá các vị trí tuyển dụng và cơ hội phát triển nghề nghiệp tại TNH Hospital Group.',
        },
        '/bao-chi-noi-ve-tnh': {
            title: 'Báo chí nói về TNH | TNH Hospital Group',
            description: 'Tổng hợp tin tức, bài viết và góc nhìn báo chí về TNH Hospital Group.',
        },
        '/lien-he': {
            title: 'Liên hệ TNH Hospital Group',
            description: 'Thông tin liên hệ, tổng đài và các kênh hỗ trợ chính thức của TNH Hospital Group.',
        },
        '/dat-lich-kham': {
            title: 'Đặt lịch khám | TNH Hospital Group',
            description: 'Đặt lịch khám với bác sĩ và lựa chọn cơ sở y tế phù hợp trong hệ thống TNH Hospital Group.',
        },
        '/san-pham-dich-vu': {
            title: 'Sản phẩm và dịch vụ y tế | TNH Hospital Group',
            description: 'Khám phá các sản phẩm và dịch vụ chăm sóc sức khỏe của TNH Hospital Group.',
        },
        '/quan-he-co-dong': {
            title: 'Quan hệ cổ đông | TNH Hospital Group',
            description: 'Công bố thông tin, tài liệu và tin tức dành cho cổ đông của TNH Hospital Group.',
        },
    },
    en: {
        '/': {
            title: 'TNH Hospital Group | Patient-centered healthcare',
            description:
                'TNH Hospital Group provides safe, humane and high-quality healthcare through a modern hospital network in Northern Vietnam.',
        },
        '/gioi-thieu': {
            title: 'About TNH Hospital Group | Vision 2035',
            description:
                'Discover the mission, 2035 vision, core values and development journey of TNH Hospital Group.',
        },
        '/tin-tuc': {
            title: 'Health news and updates | TNH Hospital Group',
            description: 'Read the latest health information, hospital updates and medical news from TNH Hospital Group.',
        },
        '/chuyen-gia-bac-si': {
            title: 'Doctors and medical specialists | TNH Hospital Group',
            description: 'Find doctors and medical specialists by specialty and hospital across TNH Hospital Group.',
        },
        '/co-so-y-te': {
            title: 'TNH hospital network | Modern healthcare facilities',
            description: 'Explore TNH Hospital Group locations, modern healthcare facilities and contact information.',
        },
        '/chuyen-khoa': {
            title: 'Medical specialties | TNH Hospital Group',
            description: 'Explore medical specialties, treatments and healthcare services across the TNH hospital network.',
        },
        '/goi-dich-vu': {
            title: 'Healthcare packages | TNH Hospital Group',
            description: 'Explore health screening, check-up and comprehensive care packages available at TNH hospitals.',
        },
        '/uu-dai': {
            title: 'Healthcare promotions | TNH Hospital Group',
            description: 'View the latest medical check-up and healthcare promotions from TNH Hospital Group.',
        },
        '/tuyen-dung': {
            title: 'Careers | TNH Hospital Group',
            description: 'Explore current vacancies and career development opportunities at TNH Hospital Group.',
        },
        '/bao-chi-noi-ve-tnh': {
            title: 'TNH Hospital Group in the press',
            description: 'Read media coverage, articles and news about TNH Hospital Group.',
        },
        '/lien-he': {
            title: 'Contact TNH Hospital Group',
            description: 'Find official contact details, hotlines and support channels for TNH Hospital Group.',
        },
        '/dat-lich-kham': {
            title: 'Book a medical appointment | TNH Hospital Group',
            description: 'Book a doctor appointment and choose a convenient healthcare facility within TNH Hospital Group.',
        },
        '/san-pham-dich-vu': {
            title: 'Healthcare products and services | TNH Hospital Group',
            description: 'Explore healthcare products and services available from TNH Hospital Group.',
        },
        '/quan-he-co-dong': {
            title: 'Investor relations | TNH Hospital Group',
            description: 'Access disclosures, documents and updates for TNH Hospital Group shareholders.',
        },
    },
};

const cleanSeoText = value =>
    String(value || '')
        .replace(/<[^>]*>/g, ' ')
        .replace(/&nbsp;/gi, ' ')
        .replace(/&amp;/gi, '&')
        .replace(/\s+/g, ' ')
        .trim();

const limitSeoText = (value, maxLength) => {
    const text = cleanSeoText(value);

    if (text.length <= maxLength) return text;

    const shortened = text.slice(0, maxLength + 1).replace(/\s+\S*$/, '').replace(/[,:;\s]+$/, '');

    return `${shortened || text.slice(0, maxLength).trim()}…`;
};

export const getSiteUrl = () => {
    const configuredUrl = process.env.NEXT_PUBLIC_WEB_URL || process.env.WEB_URL || DEFAULT_SITE_URL;

    return configuredUrl.replace(/\/+$/, '');
};

export const getInternalHref = (url = '/') => {
    if (!url) return '/';

    try {
        const parsed = new URL(url, DEFAULT_SITE_URL);
        const configuredHost = new URL(getSiteUrl()).hostname;
        const isTnhHost = parsed.hostname === 'tnh.com.vn' || parsed.hostname.endsWith('.tnh.com.vn');

        if (!parsed.hostname || parsed.hostname === configuredHost || isTnhHost) {
            return `${parsed.pathname || '/'}${parsed.search}${parsed.hash}`;
        }

        return url;
    } catch {
        return url;
    }
};

const getCleanPath = path => {
    const value = (path || '/').split(/[?#]/)[0] || '/';
    const normalized = value.startsWith('/') ? value : `/${value}`;

    return normalized !== '/' ? normalized.replace(/\/+$/, '') : normalized;
};

const withoutLocalePrefix = path => {
    const cleanPath = getCleanPath(path);

    return cleanPath === '/en' ? '/' : cleanPath.replace(/^\/en(?=\/)/, '');
};

export const getLocalizedUrl = (path = '/', locale = 'vn', siteUrl = getSiteUrl()) => {
    const basePath = withoutLocalePrefix(path);
    const localizedPath = locale === 'en' ? `/en${basePath === '/' ? '' : basePath}` : basePath;

    return `${siteUrl}${localizedPath === '/' ? '' : localizedPath}`;
};

export const enrichSeoForLocale = (seo = {}, {locale = 'vn', asPath = '/'} = {}) => {
    const siteUrl = getSiteUrl();
    const currentPath = getCleanPath(asPath);
    const noIndexPaths = [
        '/404',
        '/coming-soon',
        '/sap-ra-mat',
        '/tim-kiem',
        '/goi-dich-vu-v2-booking',
        '/goi-dich-vu-v2-result',
    ];
    const shouldNoIndex = noIndexPaths.some(path => currentPath === path || currentPath.startsWith(`${path}/`));
    const routePath = withoutLocalePrefix(currentPath);
    const curatedSeo = ROUTE_SEO[locale]?.[routePath];
    const title = limitSeoText(
        curatedSeo?.title || seo.title || (locale === 'en' ? 'TNH Hospital Group' : 'CTCP Tập đoàn Bệnh viện TNH'),
        65,
    );
    const description = limitSeoText(
        curatedSeo?.description ||
            seo.description ||
            (locale === 'en'
                ? 'Safe, humane and high-quality healthcare from TNH Hospital Group.'
                : 'Dịch vụ chăm sóc sức khỏe an toàn, nhân văn và chất lượng cao từ TNH Hospital Group.'),
        160,
    );
    let canonicalPath = currentPath;

    if (seo.canonical) {
        try {
            canonicalPath = new URL(seo.canonical, siteUrl).pathname;
        } catch {
            canonicalPath = getCleanPath(asPath);
        }
    }

    const canonical = getLocalizedUrl(canonicalPath, locale, siteUrl);
    const viUrl = getLocalizedUrl(canonicalPath, 'vn', siteUrl);
    const enUrl = getLocalizedUrl(canonicalPath, 'en', siteUrl);
    const openGraph = {
        ...(seo.openGraph || {}),
        url: canonical,
        title,
        description,
        locale: locale === 'en' ? 'en_US' : 'vi_VN',
        alternateLocale: locale === 'en' ? ['vi_VN'] : ['en_US'],
        siteName: seo.openGraph?.siteName || seo.openGraph?.site_name || 'TNH Hospital Group',
    };

    delete openGraph.site_name;

    return {
        ...seo,
        title,
        description,
        canonical,
        openGraph,
        ...(shouldNoIndex ? {noindex: true, nofollow: false} : {}),
        languageAlternates: [
            {hrefLang: 'vi-VN', href: viUrl},
            {hrefLang: 'en', href: enUrl},
            {hrefLang: 'x-default', href: viUrl},
        ],
    };
};
